import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, SearchBarBox, HeadlinePage } from 'components/common';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { withPermission } from 'hoc';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';


const DataModelListDumb = ({
  handleSearch,
  handleCreate,
  handleView,
  handleEdit,
  handleDelete,
  content,
  options,
  isLoaded,
  defaultValues,
  validPermission
}) => {
  const methods = useForm({ defaultValues });
  const projectId = methods.getValues("project");
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onDelete = (dataModel) => {
    handleDelete(dataModel);
  };

  const onEdit = (dataModel) => {
    handleEdit(dataModel);
  };

  const onView = (dataModel) => {
    handleView(dataModel);
  }

  const createActions = () => {
    const actions = [];
    if (validPermission(projectId, "isVisible")) actions.push({
      label: t('common.components.buttons.view'),
      icon: <VisibilityOutlinedIcon color="primary" />,
      handle: onView,
    });
    if (validPermission(projectId, "isEdit")) actions.push({
      label: t('dataModelList.components.table.edit'),
      icon: <EditOutlinedIcon color="primary" />,
      handle: onEdit,
    });
    if (validPermission(projectId, "isDelete")) actions.push({
      label: t('dataModelList.components.table.delete'),
      icon: <HighlightOffIcon color="primary" />,
      handle: onDelete,
    });

    return actions;
  }

  const columns = [
    { label: t('common.components.table.col.name'), key: 'label' }
  ];

  const actions = createActions();

  return (
    <>
      <HeadlinePage
        title="dataModelList.headline"
        buttonLabel={validPermission(projectId, "isCreate") ? "dataModelList.components.add" : ""}
        handleOnClick={handleCreate}
      />
      <SearchBarBox
        onSubmit={onSubmit}
        methods={methods}
        hideSearch={true}
        options={options}
      />
      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="dataModelList.components.titleList"
          columns={columns}
          content={content}
          actions={actions}
          loading={isLoaded}
          handleNotResults={handleCreate}
        />
      </Paper>
    </>
  );
};

export default withPermission(DataModelListDumb, "dataModels");
